import {
  DESKTOP_GAME_SOURCE_CONTRACT,
  READY_VIDEO_SOURCE_CONTRACT,
  TRAILER_VIDEO_SOURCE_CONTRACT,
} from "./sourceContract";
import { VIDEO_ICONS } from "./videoPlayer";

const escapeAttribute = (value: string): string => value
  .replaceAll("&", "&amp;")
  .replaceAll('"', "&quot;")
  .replaceAll("<", "&lt;")
  .replaceAll(">", "&gt;");


function desktopChromeVariables(): string {
  const chrome = DESKTOP_GAME_SOURCE_CONTRACT.chrome;
  const mobileDetail = DESKTOP_GAME_SOURCE_CONTRACT.mobileDetail;
  return [
    `--uses-desktop-pad-top:${chrome.appPadding.top}px`,
    `--uses-desktop-pad-right:${chrome.appPadding.right}px`,
    `--uses-desktop-pad-bottom:${chrome.appPadding.bottom}px`,
    `--uses-desktop-pad-left:${chrome.appPadding.left}px`,
    `--uses-desktop-gap:${chrome.gapPx}px`,
    `--uses-desktop-sysbar-height:${chrome.sysbarHeightPx}px`,
    `--uses-desktop-header-height:${chrome.headerMinHeightPx}px`,
    `--uses-desktop-window-button:${chrome.windowButtonPx}px`,
    `--uses-desktop-content-columns:${chrome.artboardContentColumns}`,
    `--uses-desktop-control-height:${chrome.controlMinHeightPx}px`,
    `--uses-mobile-detail-scale:${mobileDetail.scale}`,
    `--uses-mobile-controls-anchor:${mobileDetail.controlsAnchorPx}px`,
  ].join(";");
}

const desktopControl = (label: string, modifier: string): string => (
  `<span class="uses-desktop__action uses-desktop__action--${modifier}" aria-hidden="true"><svg class="uses-desktop__action-outline" width="100%" height="100%" aria-hidden="true" focusable="false"><rect x="0" y="0" width="100%" height="100%" rx="${DESKTOP_GAME_SOURCE_CONTRACT.chrome.controlMinHeightPx / 2}" vector-effect="non-scaling-stroke"/></svg><span>${label}</span></span>`
);

export interface DesktopGameMarkup {
  product: string;
  caption: string;
}

export function renderDesktopGameMarkup(logoUrl: string): DesktopGameMarkup {
  const source = DESKTOP_GAME_SOURCE_CONTRACT;
  const product = `
    <p class="uses-desktop-label">Приложение Blender Bridge</p>
    <div class="uses-desktop-frame" data-desktop-artboard-frame style="--uses-desktop-artboard-width:${source.artboard.width}px;--uses-desktop-artboard-height:${source.artboard.height}px;--uses-desktop-artboard-scale:1;--uses-desktop-artboard-offset-x:0px;--uses-desktop-artboard-offset-y:0px" data-product-source="desktop-${source.sourceRelease}" data-product-language="${source.productLanguage}" role="img" aria-label="Blender Bridge Desktop ${source.sourceRelease}, ${source.background.label} game workflow">
    <div class="uses-desktop uses-desktop__artboard" style="${desktopChromeVariables()}" data-desktop-artboard="${source.artboard.width}x${source.artboard.height}">
      <div class="uses-tunnel" data-background-variant="${source.background.id}" data-background-name="${source.background.label}" aria-label="${source.background.label}">
        <span class="uses-world-target uses-world-target--cube" data-uses-world-target="cube" aria-hidden="true"></span>
        <span class="uses-world-target uses-world-target--cyan" data-uses-world-target="cyan-lamp" aria-hidden="true"></span>
        <span class="uses-world-target uses-world-target--orange" data-uses-world-target="orange-lamp" aria-hidden="true"></span>
      </div>
      <div class="uses-desktop__windowbar" aria-hidden="true">
        <span class="uses-desktop__window-controls"><i class="uses-desktop__winbtn"><svg viewBox="0 0 14 14" aria-hidden="true"><line x1="3" y1="7" x2="11" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" /></svg></i><i class="uses-desktop__winbtn"><svg viewBox="0 0 14 14" aria-hidden="true"><rect x="4" y="1" width="9" height="9" rx="1.5" stroke="currentColor" stroke-width="1.7" fill="none" /><rect x="2" y="2" width="10" height="10" rx="1.5" stroke="currentColor" stroke-width="1.7" fill="#00030D" /></svg></i><i class="uses-desktop__winbtn uses-desktop__winbtn--close"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2L10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" /><path d="M10 2L2 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" /></svg></i></span>
      </div>
      <header class="uses-desktop__header">
        <span class="uses-desktop__brand">
          <img src="${escapeAttribute(logoUrl)}" alt="" />
          <strong>Blender Bridge</strong>
        </span>
        <span class="uses-desktop__last-operation">
          <small>${source.lastOperationLabel}</small>
          <strong>—</strong>
        </span>
        <span class="uses-desktop__settings" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" /></svg></span>
      </header>
      <div class="uses-desktop__workspace">
        <aside class="uses-desktop__left">
          <section class="uses-desktop__status">
            <strong>${source.status.title}</strong>
            <span><i></i><b>${source.status.rows[0]}</b><em>Online</em></span>
            <span><i></i><b>${source.status.rows[1]}</b><em>Online</em></span>
          </section>
          <section class="uses-desktop__controls">
            ${desktopControl(source.controls[0], "launch")}
            ${desktopControl(source.controls[1], "stop")}
            ${desktopControl(source.controls[2], "orange")}
            ${desktopControl(source.controls[3], "orange")}
            ${desktopControl(source.controls[4], "share")}
          </section>
        </aside>
        <section class="uses-desktop__history">
          <header><strong>${source.history.title}</strong><span><i>${source.history.actions[0]}</i><i>${source.history.actions[1]}</i></span></header>
          <div class="uses-desktop__history-field" aria-hidden="true"></div>
        </section>
      </div>
      <footer class="uses-desktop__footer"><span>${source.footer.version}</span><span>${source.footer.ports}</span></footer>
    </div>
    </div>`;

  return {
    product,
    caption: "",
  };
}

export function renderSiteSelfProofMarkup(_logoUrl?: string): string {
  return `
    <div class="uses-site-flip-shell" data-site-flip-shell>
      <div class="uses-site-flip-host" data-site-flip-host aria-label="Область раскрытия текущего участка сайта">
        <span class="uses-site-flip-miniature-target" data-site-miniature-target aria-hidden="true"></span>
      </div>
    </div>`;
}

export interface VideoProofMarkup {
  ready: string;
  trailer: string;
}

export function renderVideoProofMarkup(): VideoProofMarkup {
  const player = (id: string, src: string, label: string, fullscreenSrc?: string): string => `
    <div class="bb-video-player" data-bb-video-player="${id}" data-paused="true">
      <video class="uses-video-frame__media" src="${escapeAttribute(src)}" ${fullscreenSrc ? `data-embedded-src="${escapeAttribute(src)}" data-fullscreen-src="${escapeAttribute(fullscreenSrc)}"` : ""} preload="metadata" playsinline muted loop aria-label="${label}"></video>
      <div class="bb-video-player__controls" role="group" aria-label="Управление видео: ${label}">
        <input class="bb-video-player__seek" data-video-seek type="range" min="0" max="1000" value="0" step="1" aria-label="Позиция видео" />
        <button type="button" class="bb-video-player__button bb-video-player__button--play" data-video-action="play" aria-label="Воспроизвести">${VIDEO_ICONS.play}</button>
        <span class="bb-video-player__time" data-video-time aria-hidden="true">0:00</span>
        <button type="button" class="bb-video-player__button" data-video-action="mute" aria-label="Включить звук" aria-pressed="false">${VIDEO_ICONS.muted}</button>
        <input class="bb-video-player__volume" data-video-volume type="range" min="0" max="100" value="0" step="1" aria-label="Громкость видео" />
        <button type="button" class="bb-video-player__button" data-video-action="fullscreen" aria-label="На весь экран">${VIDEO_ICONS.fullscreen}</button>
      </div>
      <span class="bb-video-player__status" data-video-status role="status"></span>
    </div>`;
  return {
    ready: player("logo", READY_VIDEO_SOURCE_CONTRACT.src, "Представление логотипа Blender Bridge"),
    trailer: player("trailer", TRAILER_VIDEO_SOURCE_CONTRACT.embeddedSrc, "Официальный трейлер Blender Bridge", TRAILER_VIDEO_SOURCE_CONTRACT.src),
  };
}

export { renderFreelanceProofMarkup } from "./freelanceMarkup";
export { renderCapabilitiesProofMarkup } from "./creativeMarkup";
